<template>
  <li class="nav-item dropdown">
    <a
      class="nav-link dropdown-toggle mt-2 mt-lg-0 mb-lg-0 py-1 py-lg-3"
      href="#"
      id="navbarDropdown"
      role="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <font-awesome-icon
        icon="user-circle"
        aria-label="Menu usuário"
        title="Menu usuário"
      />
    </a>
    <ul
      class="dropdown-menu dropdown-menu-end"
      aria-labelledby="navbarDropdown"
    >
      <li>
        <p class="dropdown-item-text">{{ usuario.nomeCompleto }}</p>
      </li>
      <slot name="after-nome-usuario"></slot>

      <li><hr class="dropdown-divider" /></li>
      <slot name="before-logout"></slot>
      <li>
        <button class="dropdown-item" @click="fnLogout">
          <font-awesome-icon
            icon="sign-out-alt"
            aria-label="Sair"
            title="Sair"
          />
          Sair
        </button>
      </li>
    </ul>
  </li>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserCircle, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
/* add icons to the library */
library.add(faUserCircle, faSignOutAlt);

export default {
  name: "PiwebMenuUsuario",
  components: { FontAwesomeIcon },
  props: {
    usuario: {
      type: Object,
      default: () => {
        return { nomeCompleto: "Nome Sobrenome" };
      },
    },
    fnLogout: {
      type: Function,
      default: () => {
        alert("Logout!");
      },
    },
  },
};
</script>

<style scoped>
.navbar-nav .dropdown-menu {
  min-width: 20em;
}

.navbar-light .navbar-nav .nav-link:focus,
.navbar-light .navbar-nav .nav-link:hover {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-nav .nav-link:focus,
.navbar-nav .nav-link:hover {
  background-color: #e7e7e7;
}
</style>